import { configureStore } from "@reduxjs/toolkit";

import authReducer from "features/auth/authSlice";
import userReducer from "features/user/userSlice";
import employeeReducer from "features/employee/dataStore/employeeSlice";
import organizationReducer from "features/organization/organizationSlice";
import dtrReducer from "features/dtr/dtrSlice";
import maintenanceSlice from "features/maintenance/dataStore/maintenanceSlice";
import messageSlice from "features/Messages/dataStore/messageSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        employee: employeeReducer,
        organization: organizationReducer,
        dtr: dtrReducer,
        maintenance: maintenanceSlice,
        message: messageSlice
    }
});

export default store;
